<template>
  <loader :task="task" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { IntegrationConnection } from '@/iam/types';
import Loader from '@/components/loading/AsyncLinearProgress.vue';
import repository from './integration-connection-repository';

interface Data {
  task: Promise<IntegrationConnection[]>|null,
}

export default defineComponent({
  emits: ['loaded'],
  components: {
    Loader,
  },
  props: {
    accountId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  watch: {
    accountId: {
      handler(): void {
        this.load();
      },
      immediate: true,
    },
  },
  methods: {
    load(): void {
      this.task = repository.findAll(this.accountId);
      this.task.then((connections: IntegrationConnection[]) => {
        this.$emit('loaded', connections);
      });
    },
  },
});
</script>
